import { ThemeConfig } from 'antd'

export const mainTheme: ThemeConfig = {
  token: {
    fontFamily: 'SFProText'
  }
}